import { DEFAULT_DEV_PORT } from '@cli-constants/scaffolding.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'
import { detectDevPortFromScript } from './detect-dev-port-from-script.js'

export function detectDevPort(cwd: string): number {
  const pkg = readProjectPackageJson(cwd)
  if (!pkg) return DEFAULT_DEV_PORT

  return detectDevPortFromScript(pkg.scripts?.dev) ?? DEFAULT_DEV_PORT
}
